import { render, staticRenderFns } from "./TimesDoGuru.vue?vue&type=template&id=979628d4&scoped=true"
import script from "./TimesDoGuru.vue?vue&type=script&lang=js"
export * from "./TimesDoGuru.vue?vue&type=script&lang=js"
import style0 from "./TimesDoGuru.vue?vue&type=style&index=0&id=979628d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979628d4",
  null
  
)

export default component.exports